import { rankingNotes, scoringCriteria } from "@/mocks/movies";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ScoringGuide() {
  return (
    <section id="guide" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <SectionHeading
          eyebrow="关于榜单"
          title="评分口径与榜单说明"
          desc="为了让榜单可读、可比，我们把评价拆成四个维度分别打分量，再加权折算出最终评分。理解这套口径，能帮你更准确地判断一部影片是否适合自己。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {scoringCriteria.map((item, index) => (
            <article
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
          {rankingNotes.map((note) => (
            <div
              key={note.label}
              className="flex gap-3 rounded-lg border border-accent-200 bg-accent-50 p-5"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-information-line" />
              </span>
              <div>
                <h3 className="font-heading text-sm font-bold text-foreground-950">{note.label}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{note.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}